/**
 * Description: Measures and reports web vitals metrics for performance monitoring.
 * Tracks Cumulative Layout Shift (CLS), First Input Delay (FID), First Contentful Paint (FCP),
 * Largest Contentful Paint (LCP), and Time to First Byte (TTFB) to help identify performance bottlenecks.
 * @param {Function} onPerfEntry - Callback function to receive performance metrics.
 * @returns {void}
 */
const reportWebVitals = onPerfEntry => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
